import { required, useTranslate } from "ra-core";
import { TextInput } from "@/components/admin/text-input";
import { SelectInput } from "@/components/admin/select-input";
import { Separator } from "@/components/ui/separator";
import { useIsMobile } from "@/hooks/use-mobile";

import { useConfigurationContext } from "../root/ConfigurationContext";

/**
 * CHAMP family form: name, phone, how they found us, address and notes.
 * Atomic's company fields (logo, website, LinkedIn, size, revenue, tax ID,
 * context links, account manager) are left out; their database columns stay.
 */
export const CompanyInputs = () => {
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col gap-4 p-1">
      <FamilyNameInput />
      <div className={`flex gap-6 ${isMobile ? "flex-col" : "flex-row"}`}>
        <div className="flex flex-col gap-10 flex-1">
          <FamilyContactInputs />
          <FamilyNotesInputs />
        </div>
        <Separator orientation={isMobile ? "horizontal" : "vertical"} />
        <div className="flex flex-col gap-8 flex-1">
          <FamilyAddressInputs />
        </div>
      </div>
    </div>
  );
};

const FamilyNameInput = () => {
  const translate = useTranslate();
  return (
    <TextInput
      source="name"
      className="w-full h-fit"
      validate={required()}
      helperText={false}
      placeholder={translate("resources.companies.fields.name", {
        _: "Family name",
      })}
    />
  );
};

const FamilyContactInputs = () => {
  const translate = useTranslate();
  const { companySectors } = useConfigurationContext();
  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-lg font-semibold">
        {translate("resources.companies.field_categories.contact")}
      </h6>
      <TextInput source="phone_number" helperText={false} />
      <SelectInput
        source="sector"
        choices={companySectors}
        optionText="label"
        optionValue="value"
        helperText={false}
      />
    </div>
  );
};

const FamilyAddressInputs = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-lg font-semibold">
        {translate("resources.companies.field_categories.address")}
      </h6>
      <TextInput source="address" helperText={false} />
      <TextInput source="city" helperText={false} />
      <TextInput source="state_abbr" helperText={false} />
      <TextInput source="zipcode" helperText={false} />
    </div>
  );
};

const FamilyNotesInputs = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-lg font-semibold">
        {translate("resources.companies.field_categories.additional_info")}
      </h6>
      <TextInput source="description" multiline helperText={false} />
    </div>
  );
};
